import { render, staticRenderFns } from "./customerscore.vue?vue&type=template&id=3776f4c2&"
import script from "./customerscore.vue?vue&type=script&lang=js&"
export * from "./customerscore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports